// extracted by mini-css-extract-plugin
export default {"labelTxt":"globalTabStyle_labelTxt__gIPdK"};